/**
 * This module updates the result counter when number of stores that are shown have changed.
 *
 * @author  Meinaart van Straalen
 **/

import $ from 'jquery';
import Singleton from 'components/utils/Singleton';
import createLogger from 'components/logger/Logger';
import EventTypes from 'components/EventTypes';
import StoreFinderComponent from './StoreFinderComponent';
import 'jquery.extendPrototype';

const Logger = createLogger('ResultCounter');

function ResultCounter(settings) {
  Logger.info('Created');

  StoreFinderComponent.call(this, settings, module);
  this.units = document.querySelectorAll(this.settings.unitSelector);
  this.wrapper = document.querySelector(this.settings.wrapperSelector);
  this.scrollContainerTitle = document.querySelector(this.settings.scrollContainerTitleSelector);
  this.bindEvents();
}

$.extendPrototype(ResultCounter, StoreFinderComponent.prototype, {
  units: undefined,
  wrapper: undefined,

  settings: {
    selector: '.js-storeFinder-filter-resultCounter',
    unitSelector: '.js-storeFinder-filter-resultCounterItems',
    wrapperSelector: '.js-storeFinder-bar-resultCounter',
    scrollContainerTitleSelector: '.js-storeFinder-bar-scrollArea-title',
  },

  /**
   * Bind events
   */
  bindEvents() {
    document.jq
      .on(EventTypes.STOREFINDER_GET_STORES, this.onUpdateEvent.bind(this))
      .on(EventTypes.STOREFINDER_GET_STORES_REQUEST, this.onRequestEvent.bind(this))
      .on(EventTypes.STOREFINDER_STORES_FILTERED, this.onUpdateEvent.bind(this));
  },

  /**
   * Add loading state when data is being loaded
   */
  onRequestEvent() {
    this.$element.text('');
    this.wrapper.classList.add('is-loading');
    this.wrapper.classList.remove('hidden');
    this.scrollCReveal();
    this.units.forEach(element => (element.textContent = element.dataset.loading));
  },

  /**
   * Handle event.
   * @param  {object} event     jQuery event object
   * @param  {object} eventData Data belonging to event
   */
  onUpdateEvent(event, eventData) {
    if (eventData && eventData.numResults !== undefined) {
      Logger.debug('update number of results:', eventData.numResults);

      this.wrapper.classList.remove('is-loading');
      this.$element.html(`<span data-cs-capture>${eventData.numResults}</span>`);

      this.units.forEach(element => {
        const numResults =
          eventData.numResults === 1 ? element.dataset.single : element.dataset.plural;
      element.innerHTML = `<span data-cs-capture>${numResults}</span>`;
    });
    }
  },
  isHidden(comp) {
    return $(comp).hasClass("hidden");
  },
  scrollCReveal() {
    if (!this.isHidden(this.scrollContainerTitle)) {
      $(this.scrollContainerTitle).toggleClass("hidden");
    }
  }
});

export default Singleton.create(ResultCounter, 'ResultCounter');
